import { render, staticRenderFns } from "./filosofia.vue?vue&type=template&id=8a99ef04&"
import script from "./filosofia.vue?vue&type=script&lang=js&"
export * from "./filosofia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports